import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import GlobalHelper from '../common/GlobalHelper.jsx';
import NewBankAccountOnFileModal from "../common/bank-account/NewBankAccountOnFileModal";
import ActionButton from "../common/button/actionbutton.component.jsx";
import ConfirmButton from "../common/button/confirmbutton.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import StandardList from '../common/listing/list.component.jsx';
import NewSEPABankAccountOnFileModal from "../common/sepa/NewSEPABankAccountOnFileModal";
import Integrations from '../integration/Integrations.jsx';
import BankAccountLabel from "../payment/bankaccount.component.jsx";
import { PAYMENT_METHOD } from '../state/helpers/Payment';
import { INTEGRATION_KEY } from "../state/integration/Constants";
import { FeatureIntegratedPaymentSEPA } from '../state/integration/IntegrationFeatureKeys';
import TestPaymentMethodBadge from './TestPaymentMethodBadge';
class BankAccountsOnFileListByContact extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            modal: '',
            contactId: '',
            myAccountBilling: false,
            contact: null,
            organization: null,
            customerSelected: '',
            paymentIntegrationKey: AppContext.getPaymentIntegrationKey(),
            enableIntegratedPayment: AppContext.hasFeatureIntegration(Features.IntegratedPaymentBankTransfer),
            sepaIntegration: AppContext.getIntegrationByFeature(FeatureIntegratedPaymentSEPA),
        }
        this.className = this.props.className || ''
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.deleteBankAccount = this.deleteBankAccount.bind(this)
        this.setBankAccountDefault = this.setBankAccountDefault.bind(this)
        this.openAddNewBankAccountModal = this.openAddNewBankAccountModal.bind(this)
        this.shouldShowAddBankButton = this.shouldShowAddBankButton.bind(this)
    }

    componentDidMount() {
        const contactId = this.props.contactId || ''
        if (contactId) {
            this.loadContact(contactId)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.contactId) {
            this.loadContact(nextProps.contactId)
        }
    }


    loadContact(contactId, callback) {
        const next = callback || function () { }
        let url = '/contacts/' + contactId

        AppContext.getApiClient().get(url).then(r => {
            this.setState({
                contactId: contactId,
                contact: r,
            }, () => {
                next()
            })
        })
    }

    deleteBankAccount(bankAccountId) {
        return function (e) {
            e.preventDefault()
            let url = '/contacts/' + this.state.contactId + '/bank-accounts-on-file/' + bankAccountId
            AppContext.getApiClient().delete(url).then(r => {
                this.loadContact(this.state.contactId)
            })
        }.bind(this)
    }

    setBankAccountDefault(bankAccountId) {
        return function (e) {
            e.preventDefault()
            let url = '/contacts/' + this.state.contactId + '/bank-accounts-on-file/' + bankAccountId + '/default'
            AppContext.getApiClient().put(url, {}).then(r => {
                this.loadContact(this.state.contactId)
            })
        }.bind(this)
    }

    headers() {
        let headers = [
            <FormattedMessage
                id="customers.bank_accounts_on_file.list.headers.cardholder_name_label"
                defaultMessage="Account holder name"
            />,
            <FormattedMessage
                id="customers.bank_accounts_on_file.list.headers.bank_label"
                defaultMessage="Bank name"
            />,
            <FormattedMessage
                id="customers.bank_accounts_on_file.list.headers.bank_account_label"
                defaultMessage="Bank account"
            />,
            <FormattedMessage
                id="customers.cards_on_file.list.headers.created_at_label"
                defaultMessage="Saved at"
            />,
            <FormattedMessage
                id="customers.cards_on_file.list.headers.processor_label"
                defaultMessage="Processor"
            />,
            '',
        ]
        return headers
    }

    row(bankAccount) {
        const integration = GlobalHelper.getIntegrationById(bankAccount.attributes.integrationConfigurationId)
        const locationIds = integration ? integration.attributes.locationIds : []
        let locationName = ''
        if (locationIds.length > 0) {
                locationName = '(' + locationIds.map(id => {
                    return GlobalHelper.getLocationById(id).attributes.name
                }).join(", ") + ')'
        }

        let row = [
            <span>
                {bankAccount.attributes.bankAccount.attributes.accountHolderName}
                {bankAccount.attributes.isDefault ? <span className="badge badge-primary ml-2">
                    <FormattedMessage
                        id="cards_on_file.default_label"
                        defaultMessage="Default"
                    />
                </span> : ''}
                {bankAccount.attributes.isTestPaymentMethod ? <TestPaymentMethodBadge paymentMethodType={PAYMENT_METHOD.BANK_ACCOUNT} /> : ''}
            </span>,
            <span>{bankAccount.attributes.bankAccount.attributes.bankName}</span>,
            <BankAccountLabel value={bankAccount.attributes.bankAccount} />,
            <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                weekday='long'
                value={new Date(bankAccount.attributes.createdAt)} />,
            <span>
                {Integrations.getIntegrationNameFromKey(bankAccount.attributes.integrationKey)} {locationName}
            </span>,
        ]
        row.push(<div className={'w-100 d-flex justify-content-end'}>
            {!bankAccount.attributes.isDefault ? <ActionButton
                className={'btn btn-sm btn-outline-primary mr-2'}
                onClick={this.setBankAccountDefault(bankAccount.id)}
            >
                <FormattedMessage
                    id="customer.cards_on_file.default_btn"
                    defaultMessage="Use by default"
                />
            </ActionButton> : ''}
            <ConfirmButton
                className={'btn btn-sm btn-outline-danger'}
                identifier={bankAccount.attributes.bankAccount.attributes.bankName.toUpperCase() + ' - ' + bankAccount.attributes.bankAccount.attributes.last4}
                onClick={this.deleteBankAccount(bankAccount.id)}
            >
                <Icon value={'trash'} className={'mr-1'} />
                <FormattedMessage
                    id="customer.cards_on_file.delete_btn"
                    defaultMessage="Remove"
                />
            </ConfirmButton>
        </div>)
        return row
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    shouldShowAddBankButton() {
        if (this.state.sepaIntegration) {
            //to be removed when ready to deploy
            if (AppContext.getOptions().environment === "prod") {
                return false
            }

            return this.state.sepaIntegration.attributes.enabledFeatures.sepa_debit
        } else if (this.state.enableIntegratedPayment) {
            return this.state.paymentIntegrationKey !== INTEGRATION_KEY.STRIPE
        }

        return false
    }

    openAddNewBankAccountModal(event) {
        event.preventDefault()

        let getModal
        switch (this.state.paymentIntegrationKey) {
        case INTEGRATION_KEY.STRIPE:
            getModal = <NewSEPABankAccountOnFileModal
                myAccountBilling={this.state.myAccountBilling}
                onClose={this.handleCloseModal}
                onSubmit={() => this.loadContact(this.state.contactId)}
                contactId={this.state.contactId}
                saveAndChargeLater={true}
                publicKey={this.state.sepaIntegration.attributes.configuration.publicKey}
                integrationKey={this.state.paymentIntegrationKey}/>
            break
        default:
            getModal = <NewBankAccountOnFileModal
                contactId={this.state.contactId}
                integrationKey={this.state.paymentIntegrationKey}
                onSubmit={() => {
                    this.loadContact(this.state.contactId)
                    this.handleCloseModal()
                    }
                }
                onClose={this.handleCloseModal}/>
        }

        this.setState({
            modal: getModal
        })
    }

    render() {
        if (!this.state.contact) {
            return <div />
        }

        const bankAccountsOnFile = this.state.contact.attributes.bankAccountsOnFile
            .filter(c => c.attributes.integrationKey === this.state.paymentIntegrationKey)
            .map(item => this.row(item))
        const headers = bankAccountsOnFile.length > 0 ? this.headers() : []

        return (
            <div>
                <StandardList
                    smallLine={true}
                    className="row pt-0"
                    headers={headers}
                    rows={bankAccountsOnFile}
                    footer={<div className="col-12 d-flex d-flex justify-content-between align-items-center">
                        <div></div>
                        {this.shouldShowAddBankButton() &&
                            <div>
                                <button onClick={this.openAddNewBankAccountModal} className="btn btn-sm btn-primary">
                                    <Icon value={'plus-circle'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="customers.cards_on_file.new_bank_acct_btn"
                                        defaultMessage="Add a bank account"
                                    />
                                </button>
                            </div>
                        }
                    </div>}
                />
                {this.state.modal}
            </div>
        );
    }
}

export default BankAccountsOnFileListByContact





// WEBPACK FOOTER //
// ./src/customer/bankaccountonfileslist.component.jsx